import React, { Component, useContext, createContext } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import styled, { ThemeProvider } from 'styled-components';
import { moduleName, IStore } from './store';
import Header from './components/Header';
import './index.less';
import { DictContext } from '../../modules/context';

const theme = process.env.REACT_APP_THEME || {};

interface IState {
  winHeight: number;
}
interface IProps {
  store: IStore;
}

const LoadingWrap = styled.div`
  text-align: center;
  margin-top: 100px;
`;

@inject(stores => ({ store: stores[moduleName] }))
@observer
class Frame extends Component<IProps, IState> {
  constructor(props) {
    super(props);
    this.state = {
      winHeight: window.innerHeight,
    };
  }

  componentDidMount() {
    const { store } = this.props;
    store.init();
  }

  resize = () => {
    this.setState({
      ...this.state,
      winHeight: window.innerHeight,
    });
    // this.winHeight = window.innerHeight;
  };

  screenChange = () => {
    window.addEventListener('resize', this.resize);
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  render() {
    const { children, store } = this.props;
    const { collectionas, loading, platforms } = store;
    return (
      <ThemeProvider theme={theme}>
        {!loading ? (
          collectionas && (
            <DictContext.Provider value={{ collectionas, platforms }}>
              <div className="shopify-app">
                {Header && collectionas ? (
                  <Header pathname={window.location.pathname}></Header>
                ) : (
                  ''
                )}
                <div className="app-content-contaner">{children}</div>
              </div>
            </DictContext.Provider>
          )
        ) : (
          <LoadingWrap>
            <Spin></Spin>
          </LoadingWrap>
        )}
      </ThemeProvider>
    );
  }
}

export default Frame;
